import React from 'react'
import { IconButton, Dialog, DialogContent } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Close } from '@mui/icons-material'
import { BGVariants } from '../../types/heroTextSection'
import { ModalVariants } from '../../types/modal'

import useMultiStepModal from './useMultiStepModal'

interface Props {
  steps: React.ReactElement[]
  color?: BGVariants | null
  showCloseButton?: boolean
  variant: ModalVariants | null
}

const MultiStepModal: React.FC<Props> = ({
  steps,
  color,
  showCloseButton = false,
  variant,
}) => {
  const { classes, cx } = useStyles()
  const { open, handleClose, currentStep } = useMultiStepModal()

  return (
    <Dialog
      classes={{
        paper: cx({
          [classes.dialogPaper]: true,
          [classes.dialogPaperLanguageSwitcher]:
            variant === ModalVariants.LanguageSwitcher,
        }),
      }}
      open={open}
      onClose={handleClose}
    >
      <DialogContent
        className={cx({
          [classes.dialogContent]: true,
          [classes.bg]: !color || color === BGVariants.DarkPrimary,
          [classes.bgWhite]: color === BGVariants.White,
          [classes.dialogContentReducedPadding]:
            variant === ModalVariants.ReducedPadding ||
            variant === ModalVariants.LanguageSwitcher,
        })}
      >
        {steps[currentStep]}
      </DialogContent>
      {showCloseButton && (
        <IconButton
          className={classes.iconButton}
          onClick={handleClose}
          size="large"
        >
          <Close />
        </IconButton>
      )}
    </Dialog>
  )
}

const useStyles = makeStyles()((theme) => ({
  backdrop: {
    backgroundColor: 'orange',
  },
  bg: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.background.default,
  },
  bgWhite: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  dialogContent: {
    padding: '3.31em 3.41em 2.99em',
    textAlign: 'center',

    '&:first-child': {
      paddingTop: '3.31em',
    },

    '& h1': {
      [theme.breakpoints.down('md')]: {
        fontSize: '1.94em',
      },
    },

    [theme.breakpoints.down('md')]: {
      padding: '3.07em 1.5em 2.34em',
    },
  },
  dialogContentReducedPadding: {
    padding: '1.25em 2em 1.56em',
    '&:first-child': {
      paddingTop: '1.25em',
    },
    [theme.breakpoints.down('md')]: {
      padding: '1.25em 6% 1.63em',
    },
  },
  dialogPaper: {
    backgroundColor: 'inherit',
    margin: '1.5em 6% 1.5em 6%',
    maxWidth: '34.38em',
  },
  dialogPaperLanguageSwitcher: {
    maxWidth: 'unset',
  },
  iconButton: {
    color: 'inherit',
    position: 'absolute',
    right: '1rem',
    top: '1rem',
    [theme.breakpoints.down('md')]: {
      right: '.25rem',

      '& svg': {
        height: '.75em',
        width: '.75em',
      },
    },
  },
}))

export default MultiStepModal
